<div class="empty-ctrl">
  <!-- Encabezado: icono + etiqueta con contador (solo visible tras ejecutar) + temporizador -->
  <div class="empty-ctrl__head">
    <span class="empty-ctrl__icon">
      <app-image-color
        [url]="'menu-icons/calibration.svg'"
        [color]="'#999999'"
        [height]="'18px'"
        [width]="'18px'"
      ></app-image-color>
    </span>
    <span class="empty-ctrl__text">
      <span class="empty-ctrl__title">{{ "empty-modal.emptied" | translate }}</span>
      <small class="empty-ctrl__count" *ngIf="view_time && emptyItem">
        {{ emptyItem.answered }}/{{ emptyItem.total }} {{ "testing.answered-count" | translate }}
      </small>
    </span>
    <app-minute-timer
      *ngIf="view_time"
      [type]="timerType"
      [start]="view_time"
      [class]="'m-0'"
      [minutes]="time_empty"
    ></app-minute-timer>
  </div>

  <!-- Boton Detener -->
  <button
    *ngIf="countOn > 0"
    type="button"
    [disabled]="disabled"
    class="empty-ctrl__btn is-stop"
    (click)="submitEmpty(true)"
    [ngbPopover]="stopInfo"
    triggers="mouseenter:mouseleave"
    placement="right"
    container="body"
  >
    <span class="empty-ctrl__btn-label">{{ "empty-modal.stop-emptying" | translate }}</span>
    <em class="fa fa-power-off" aria-hidden="true"></em>
  </button>
  <ng-template #stopInfo>
    <ul class="empty-ctrl__popover-list">
      <li *ngFor="let name of feedersOn">
        <em class="fa fa-circle mr-1 text-danger" style="font-size:8px"></em>{{ name }}
      </li>
    </ul>
  </ng-template>

  <!-- Boton Ejecutar -->
  <button
    *ngIf="countOff > 0"
    type="button"
    [disabled]="disabled"
    class="empty-ctrl__btn is-run"
    (click)="submitEmpty(false)"
    [ngbPopover]="runInfo"
    triggers="mouseenter:mouseleave"
    placement="right"
    container="body"
  >
    <span class="empty-ctrl__btn-label">{{ "testing.empty-feeder" | translate }}</span>
    <em class="fa fa-power-off" aria-hidden="true"></em>
  </button>
  <ng-template #runInfo>
    <ul class="empty-ctrl__popover-list">
      <li *ngFor="let name of feedersOff">
        <em class="fa fa-circle mr-1 text-success" style="font-size:8px"></em>{{ name }}
      </li>
    </ul>
  </ng-template>
</div>
